import { TELOS_EVM_CHAIN } from "../config";

class EVMSession {
    #walletAPI;

    get provider() {
        return this.#walletAPI.provider;
    }

    get isNetworkSupported() {
        // We primarily only support logging in with 1 chain (Telos EVM)
        return (this.chainID === TELOS_EVM_CHAIN.chainID)
    }

    constructor(walletAPI, address, chainID) {
        this.#walletAPI = walletAPI;
        this.address = address;
        this.chainID = chainID;
    };

    // Wallet APIs
    async switchChain(chainID) {
        try {
            await this.#walletAPI.switchChain(chainID);
            this.chainID = chainID;
        }
        catch(error) {
            if (error.code === 4902 || error.error?.code === 4902) {
                await this.#walletAPI.addChain(chainID);
                return this.switchChain(chainID);
            }

            throw error;
        }
    };
}

export default EVMSession;